<div class="report-model">
<div class="report-model-header">
  <div class="info">
    <h3>
      {{ "reports.property_prices" | translate }}
      <span class="totalTransaction">({{ propertyCount }} {{ "reports.Records" | translate }})</span>
    </h3>
  </div>
</div>
</div>

<div class="main-table">
    <table class="table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">
                    <th *ngIf="tableColumn.isSortable; else noSort" mat-sort-header="{{ tableColumn.header }}"
                        [class.custom-bg-th]="tableColumn.border">
                        <ng-container *ngIf="tableColumn?.recordType; else otherColumn">
                            <span class="header_label record_type">
                                {{ tableColumn?.columnName | translate }}
                                <span class="">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                                <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                            </span>
                        </ng-container>
                        <ng-template #otherColumn>
                            <span class="header_label">
                                {{ tableColumn?.columnName | translate }}
                                <span class="text-transform-normal">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                            </span>
                        </ng-template>
                    </th>
                    <ng-template #noSort>
                        <th [class.custom-bg-th]="tableColumn.border">
                            <ng-container *ngIf="tableColumn?.recordType; else otherColumnNoSort">
                                <div class="mat-column">
                                    <span class="header_label record_type">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                                        <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                    </span>
                                </div>
                            </ng-container>
                            <ng-template #otherColumnNoSort>
                                <div class="mat-column">
                                    <span class="header_label">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="text-transform-normal">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                                    </span>
                                </div>
                            </ng-template>
                        </th>
                    </ng-template>
                </ng-container>
            </tr>
        </thead>
          <tbody>
     

    <!-- Data rows -->
        <tr *ngFor="let element of tableData; let i = index" [ngClass]="{ hideTable: showLoader }"
            [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
            [class.blur-content]="element['NODATA']">
        <td>{{ element?.transaction_date || '-' }}</td>
        <td>{{ element?.price_type || '-' }}</td>
        <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td>
        <td>{{ element?.transaction_area ? (element.transaction_area | number:'1.0-1') : '-' }}</td>
        <td [ngClass]="{'outlier-text': element['outlier']}">
            {{ element?.transaction_rate ? (element.transaction_rate | number:'1.0-1') : '-' }}
            <span class="outlier" *ngIf="element['outlier'] && element?.transaction_rate">
            {{ 'reports.outlier' | translate }}
            </span>
        </td>
        </tr>
        <!-- Loader -->
      <tr *ngIf="showLoader" class="loader-tr">
        <td [attr.colspan]="tableColumns.length" class="text-center p-0">
          <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
        </td>
      </tr>

    </tbody>
    </table>
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>

<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="propertyCount > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ propertyCount | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="propertyCount > 3"> {{(propertyCount - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container>
        <ng-container *ngIf="propertyCount <= 3">{{'more_rows'| translate}}</ng-container>.
    </p>
    <mat-paginator *ngIf="propertyCount > 20" [disabled]="showLoader || LockReport" class="default-pagination"
        [length]="propertyCount" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>
    <div class="go-to-page d-flex align-items-center" *ngIf="propertyCount > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>  